import React, { useEffect, useRef, useState } from "react";
import { DatePicker, Form, Input, Modal, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import { save } from "../../../../../features/save/saveSlice";
import { disabledPastDate, formatText, normalizeDateToLocalYear } from "../../../../../utils";
import { setActiveObj } from "../../../../../features/folder/folderSlice";

const { TextArea } = Input;

const PublishModal = ({ open, handleCancel,selectedItem }) => {
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { saving } = useSelector((state) => state.save);
  const { activeObjJob, viewMode } = useSelector((state) => ({
    activeObjJob: state.folder.activeObj["job"],
    viewMode: state.folder.viewMode,
  }));
  const [startDate, setStartDate] = useState();
  const onFinish = async (data) => {
    const { jobAdvertStartDate, jobAdvertEndDate } = data;

    // Convert to Day.js objects
    const start = dayjs(jobAdvertStartDate);
    const end = dayjs(jobAdvertEndDate);

    // Validate date selection
    if (!start.isValid() || !end.isValid()) {
      return toast.error("Both start and end dates are required.");
    }

    if (end.isBefore(start)) {
      return toast.error("End date cannot be before start date.");
    }

    if (end.diff(start, "year", true) > 1) {
      return toast.error("End date must be within 1 year of the start date.");
    }

    const res = await dispatch(
      save({
        url: "api/v1/jobs",
        jobId: activeObjJob?.jobId,
        jobAdvertStatus: selectedItem,
        jobAdvertStartDate: normalizeDateToLocalYear(data?.jobAdvertStartDate),
        jobAdvertEndDate: normalizeDateToLocalYear(data?.jobAdvertEndDate),
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await dispatch(
        setActiveObj({ key: "job", data: res?.payload?.data?.result })
      );
      await handleCancel();
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  return (
    <>
      <Modal
        className="modal-btn mod-height mod-footer"
       title={`${formatText(selectedItem)} Job`}
        open={open}
        onOk={onFinish}
        onCancel={handleCancel}
        width={580}
      >
        <Form
          layout="vertical"
          ref={formRef}
          name="control-ref"
          onFinish={onFinish}
          className=" "
          style={{
            maxWidth: "100%",
          }}
          form={form}
        >
          <div className="text-[#0E0E0E] text-[1rem] font-[400] font-dmSans">
            Create advert to announce this job vacancy. The advert will go live
            once you publish it.{" "}
          </div>
          <div className="grid grid-cols-2 gap-x-5 mt-[1.5rem]">
            <Form.Item
              label="From"
              name="jobAdvertStartDate"
              rules={[
                {
                  required: true,
                  message: "From date is required",
                },
              ]}
            >
              <DatePicker
                placeholder="Select Date"
                className="input"
                format={"DD-MM-YYYY"}
                disabledDate={disabledPastDate}
                onChange={(date) => setStartDate(date)}
              />
            </Form.Item>

            <Form.Item
              label="To"
              name="jobAdvertEndDate"
              rules={[
                {
                  required: true,
                  message: "To date is required",
                },
              ]}
            >
              <DatePicker
                placeholder="Select Date"
                className="input"
                format={"DD-MM-YYYY"}
                disabledDate={(current) =>
                  disabledPastDate(current) ||
                  (startDate &&
                    current.isAfter(startDate.clone().add(1, "year")))
                }
              />
            </Form.Item>
          </div>
          <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
            <div className="justify-start"></div>
            <div className="justify-end flex items-center gap-x-2">
              <div className="w-[150px]">
                <button
                  key="back"
                  type="button"
                  onClick={handleCancel}
                  className="cstm-btn-2"
                >
                  Cancel
                </button>
              </div>

              <div className="w-[150px]">
                <button
                  key="submit"
                  type="submit"
                  className="cstm-btn"
                  disabled={saving}
                >
                  {saving ? <Spin /> : "Publish"}
                </button>
              </div>
            </div>
          </div>
        </Form>
      </Modal>
    </>
  );
};
export default PublishModal;
